module.exports = __webpack_public_path__ + "static/media/UploadedByUs.a080178a.svg";